module.exports = __webpack_public_path__ + "img/fdi-logo-white.51e59371.png";